export const getUser = () => {
  try {
    const user = localStorage.getItem('prismoline_user');
    return user ? JSON.parse(user) : null;
  } catch { return null; }
};

export const getToken = () => localStorage.getItem('prismoline_token');

export const setAuth = (token, user) => {
  localStorage.setItem('prismoline_token', token);
  localStorage.setItem('prismoline_user', JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem('prismoline_token');
  localStorage.removeItem('prismoline_user');
};

export const isAdmin = () => {
  const user = getUser();
  return user?.role === 'admin' || user?.role === 'super_admin';
};

export const isManager = () => {
  const user = getUser();
  return ['manager', 'director', 'hr', 'director_hr'].includes(user?.org_role);
};

export const isHR = () => {
  const user = getUser();
  return user?.role === 'hr' || user?.org_role === 'hr' || user?.org_role === 'director_hr' || isAdmin();
};

export const canApproveLeave = () => {
  return isAdmin() || isManager() || isHR();
};
